export default "__VITE_ASSET__DbieEoyb__"